import React from 'react';
import cn from 'classnames';

import styles from './Radio.module.css';

const Radio = ({ children, checked }) => (
  <div className="flex items-center mb-1 last:mb-0">
    <div
      className={cn(
        styles.radio,
        { [`${styles.checked}`]: checked },
        'h-2 w-2 border-black rounded-full mr-1 relative'
      )}
    />
    <p className="text-sm text-black">{children}</p>
  </div>
);

export default Radio;
